var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c("resize-observer", { on: { notify: _vm.centerColumnResize } }),
              _vm._v(" "),
              _vm.mobileBigAndBelow &&
              (_vm.brandLayout === "generic" ||
                _vm.brandKey === "sb" ||
                _vm.brandKey === "qcasino" ||
                _vm.brandKey === "pr" ||
                _vm.brandKey === "rw")
                ? _c("sports-menu-mobile", {
                    staticClass: "popular",
                    attrs: { "navigation-section": "BO_POPULAR" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "page-layout" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "left-column" },
                    [
                      _vm.brandKey === "dn" || _vm.brandKey === "dnw"
                        ? _c("div", { staticClass: "logo" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.mediaServer(
                                  "/static/brand-img/" +
                                    _vm.brandKey +
                                    "/secondary-logo-white.png"
                                ),
                                alt: _vm.brandKey
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tabletAndAbove ? _c("sports-menu") : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { ref: "centercolumn", staticClass: "center-column" },
                    [_c("router-view"), _vm._v(" "), _c("internal-error")],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabletAndAbove &&
                  (!_vm.isReadOnly || _vm.isWishBetEnabled)
                    ? _c(
                        "v-flex",
                        { staticClass: "betslip-column" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "toggleBetslipColumn",
                              class: [
                                {
                                  loggedIn: _vm.isLoggedIn,
                                  postLoginAlertExist:
                                    _vm.postLoginAlertExist &&
                                    !_vm.mobileBigAndBelow
                                },
                                { betslip_layout2: _vm.betslipLayout2 },
                                _vm.brandKey
                              ]
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "betslipTabs",
                                  class: [
                                    { noHistory: !_vm.showHistoryTabs },
                                    { loggedIn: _vm.isLoggedIn },
                                    {
                                      withBackToBetslip:
                                        _vm.brandLayout === "generic" &&
                                        _vm.betslipLayout2 &&
                                        _vm.betTypeTab !== "REGULAR"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tab",
                                      class: {
                                        active:
                                          _vm.activeBetSlipHistoryTab !==
                                            "active" &&
                                          _vm.activeBetSlipHistoryTab !==
                                            "settled",
                                        disabled: true
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setTab("BetSlip")
                                        }
                                      }
                                    },
                                    [
                                      !_vm.betslipLayout2
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "betsliptablink a-link-"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlipPage.tab.BetSlip"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.brandKey !== "qcasino" &&
                                              _vm.brandKey !== "pr" &&
                                              _vm.brandKey !== "rw" &&
                                              _vm.betsNo > 0
                                                ? _c("badge", [
                                                    _vm._v(_vm._s(_vm.betsNo))
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brandKey === "qcasino" ||
                                              (_vm.brandKey === "pr" &&
                                                _vm.betsNo > 0)
                                                ? _c("badge", [
                                                    _vm._v(
                                                      _vm._s(
                                                        "(" + _vm.betsNo + ")"
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.brandKey === "rw"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        "(" + _vm.betsNo + ")"
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.betslipLayout2 &&
                                      _vm.brandLayout === "generic"
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "betsliptablink a-link-"
                                            },
                                            [
                                              _c("badge", [
                                                _vm._v(_vm._s(_vm.betsNo))
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlipPage.tab.BetSlip"
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.brandLayout === "generic" &&
                                  _vm.betslipLayout2 &&
                                  _vm.betTypeTab !== "REGULAR"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "back_to_betslip back-to-betslip"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBetTypeTab(
                                                    "REGULAR"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.tab.label.back"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showHistoryTabs === true &&
                                  _vm.brandKey === "boyd"
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "historyTabs" },
                                          [
                                            _vm.isLoggedIn
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tab history-tab",
                                                    class: {
                                                      active:
                                                        _vm.activeBetSlipHistoryTab ===
                                                        "active"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "a-link-",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setTab(
                                                              "HistoryActive"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BetSlipPage.tab.History.active"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isLoggedIn
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tab history-tab",
                                                    class: {
                                                      active:
                                                        _vm.activeBetSlipHistoryTab ===
                                                        "settled"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "a-link-",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setTab(
                                                              "HistorySettled"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BetSlipPage.tab.History.settled"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showHistoryTabs === true &&
                                  _vm.brandKey !== "boyd" &&
                                  (!_vm.betslipLayout2 ||
                                    (_vm.betslipLayout2 &&
                                      _vm.betTypeTab === "REGULAR"))
                                    ? [
                                        _vm.isLoggedIn
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "tab history-tab",
                                                class: {
                                                  active:
                                                    _vm.activeBetSlipHistoryTab ===
                                                    "active"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setTab(
                                                      "HistoryActive"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  { staticClass: "a-link-" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlipPage.tab.History.active"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isLoggedIn
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "tab history-tab",
                                                class: {
                                                  active:
                                                    _vm.activeBetSlipHistoryTab ===
                                                    "settled"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setTab(
                                                      "HistorySettled"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  { staticClass: "a-link-" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlipPage.tab.History.settled"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("betslip"),
                          _vm._v(" "),
                          !_vm.stickyBetslip &&
                          (_vm.brandLayout === "generic" ||
                            _vm.brandKey === "boyd" ||
                            _vm.brandKey === "qcasino" ||
                            _vm.brandKey === "pr" ||
                            _vm.brandKey === "rw")
                            ? _c(
                                "div",
                                { staticClass: "banners" },
                                [
                                  _c("headlinesLight", {
                                    attrs: { category: "SidebarBanners" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabletAndAbove && _vm.isReadOnly && !_vm.isWishBetEnabled
                    ? _c(
                        "v-flex",
                        { staticClass: "betslip-column sidebarColumn" },
                        [
                          _c(
                            "div",
                            { staticClass: "banners" },
                            [
                              _c("headlinesLight", {
                                attrs: { category: "SidebarBanners" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57f4e98e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57f4e98e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SportsLayout.vue
// module id = null
// module chunks = 